<template>
  <div
    class="wa-header"
    :style="{
      background: `linear-gradient(90deg, ${brandColour} 0%, ${getDarkHeader()} 100%)`,
      color: getContrastingBrandColour(),
    }"
  >
    <div class="header">
      <div class="header-left">
        <div class="header-action"></div>
        <div class="header-text">
          <div class="header-primary">{{ headerText }}</div>
          <div class="header-sub">{{ subtitleText }}</div>
        </div>
      </div>
      <div class="header-right">
        <div class="header-action">
          <div class="header-action-icon">
            <svg
              class="download-icon"
              :style="{ stroke: getContrastingBrandColour() }"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 48 48"
            >
              <line
                fill="none"
                stroke-width="4"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-miterlimit="10"
                x1="24"
                y1="7"
                x2="24"
                y2="36"
              />
              <polyline
                fill="none"
                stroke-width="4"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-miterlimit="10"
                points="35.3137093,24.6862907 24,36 12.6862917,24.6862907 	"
              />
              <path
                fill="none"
                stroke-width="4"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-miterlimit="10"
                d="M42,34v6c0,2.2091408-1.7908592,4-4,4H10c-2.2091389,0-4-1.7908592-4-4v-6"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { default as ColourPicker } from '@/shared/services/color';

const props = defineProps({
  brandColour: {
    type: String,
    required: true,
  },
  outboundMessageColour: {
    type: String,
    required: true,
  },
  headerText: {
    type: String,
    required: true,
  },
  subtitleText: {
    type: String,
    required: true,
  },
});

function getContrastingBrandColour() {
  return ColourPicker.getContrastingColour(props.brandColour);
}

function getDarkHeader() {
  return ColourPicker.darken(props.brandColour, 12);
}
</script>

<style scoped lang="scss">
.wa-header {
  // for some reason the height/padding calculations here
  // are totally different to the real widget

  // max-height: 2.5em;
  // min-height: 2.5em;
  min-height: 1.5em;
  //padding: 1.5em 1.25em 1.5em 2.25em;
  padding: 1.25em 1.25em 1.25em 2em;

  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 8px 8px 0 0;

  .header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .header-left {
      display: flex;
      align-items: center;
      overflow: hidden;
      flex: 1;

      &.no-icons {
        margin-left: -1.25em;
      }

      .header-text {
        overflow: hidden;
        flex: 1;
      }

      .header-action {
        transition: 200ms;
        margin-right: 1em;
      }
    }

    .back-icon {
      height: 1.75em;
      width: 1.75em;
      margin: 0;
    }
    .header-right {
      display: flex;
      align-items: center;
    }

    .header-primary {
      font-size: 1.35em;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .header-sub {
      font-size: 1em;
      opacity: 0.7;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .header-action {
    position: relative;
    display: flex;
    justify-content: center;

    .header-action-icon {
      position: relative;
      width: 3em;
      height: 3em;
      align-items: center;
      display: flex;
      justify-content: center;
      border-radius: 0.3em;
    }
  }

  .download-icon {
    height: 1.5em;
    width: 1.5em;
  }
}
</style>
